import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import { Box, Divider, Paper } from '@mui/material';
import { APIRequestStatus, LoadingStatus } from '../../../constants/common';
import { AppLevelPermissions } from '../../OnBoarding/Organization/constants/onboarding.constants';
import TryAgain from '../../molecules/ErrorState/error.component';
import CircularLoader from '../../../atoms/CircularLoader/circular-loader';
import SubHeader from './sub-header/SubHeader';
import DynamicBreadcrumb from '../../../atoms/Breadcrumbs/dynamicBreadcrumb';
import NavTabBar from '../../../atoms/Tabs/nav-tab-bar';
import { getFeedbackTabs } from './utils/util';
import { fetchFeedbackPermissions } from '../../../redux/modulePermissions/action';

const FeedbackApp = () => {
  const dispatch = useDispatch();

  const { currentUserRoleId, appPermissions } = useSelector(
    (state) => state.main
  );
  const {
    feedbackPermission,
    requestProcessing: {
      [APIRequestStatus.FETCH_FEEDBACK_PERMISSIONS]: permissionsLoading,
    },
  } = useSelector((state) => state.modulePermissions);
  const { logoImage } = useSelector((state) => state && state.onBoarding);
  const tabs = getFeedbackTabs(feedbackPermission).filter((item) => item.show);

  const location = useLocation();
  const paths = location.pathname.split('/');
  const currentPath = paths[paths.length - 1];
  // const [idNameMap, setIdNameMap] = useState({});

  useEffect(() => {
    if (appPermissions && currentUserRoleId) {
      if (appPermissions[AppLevelPermissions.feedback]) {
        dispatch(
          fetchFeedbackPermissions(
            currentUserRoleId,
            appPermissions[AppLevelPermissions.feedback].id
          )
        );
      }
    }
  }, [currentUserRoleId, appPermissions]);

  if (permissionsLoading === LoadingStatus.Failure) {
    return <TryAgain />;
  }
  return (
    <Box m={4} >
      <CircularLoader show={permissionsLoading === LoadingStatus.Loading} />
      <Box>
        <SubHeader tabs={tabs} />
        <Box my={3}>
          <DynamicBreadcrumb />
          <Box mt={1}>
            <Divider />
          </Box>
        </Box>
      </Box>
      {permissionsLoading === LoadingStatus.Success && logoImage && (
        <>
          <NavTabBar list={tabs || []} />
          <Paper sx={{ p: 3 }}>
            <Outlet />
          </Paper>
        </>
      )}
    </Box>
  );
};

export default FeedbackApp;
